<template>
	<AppCard :title="getString('stations')" v-if="usersStations.length > 0">
		<template v-slot:body>
			<div class="px-10">
				<AppList :items="usersStations" />
			</div>
		</template>
	</AppCard>
	<AppBottomSheet :force-width="bottomSheetWidth" :active="openBottomSheetCategorySettings" @toggling-popup="toggleCategorySettings">
		<div v-if="!!openStationId && openBottomSheetCategorySettings">
			<KitchenStationCategoriesEditor
				:station-id="openStationId"
				@close="openBottomSheetCategorySettings = false"
			/>
		</div>
	</AppBottomSheet>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";
import AppList from "@/shared/components/AppList.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";

import KitchenStationCategoriesEditor from "@/console-new/components/plugins/KitchenStationCategoriesEditor.vue";

import {useLanguageStore, useSvgStore, useNotificationStore} from "@/shared/stores";
import {useUserStore, useKitchenMonitorsStore, useMenuStore, useMarketplaceStore} from "@/console-new/stores";

import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		let marketplaceStore = useMarketplaceStore();
		let notificationStore = useNotificationStore();
		let kitchenMonitorsStore = useKitchenMonitorsStore();
		let menuStore = useMenuStore();
		return {languageStore, menuStore, getString: languageStore.getString, kitchenMonitorsStore, showNotification: notificationStore.showNotification, marketplaceStore, userStore, getIcon: svgStore.get, readableEurValue: languageStore.readableEurValue}
	},
	name: "PluginsKitchenUsersCard",
	mixins: [WindowWidth],
	components: {AppList, AppButton, AppBottomSheet, KitchenStationCategoriesEditor, AppPopup, AppCard},
	data() {
		return {
			usersStations: [],
			openBottomSheetCategorySettings: false,
			openStationId: null,
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		sortedMenus() {
			return this.menuStore.sortedMenus;
		},
		sortedCategories() {
			return Object.values(this.menuStore.modMenu.categories).sort((a, b) => a.order_number - b.order_number);
		},
	},
	methods: {
		toggleCategorySettings(isOpen) {
			if(!isOpen) {
				this.openBottomSheetCategorySettings = false;
			}
		},
		resetStationsList(cb, force = false) {
			let currBusiness = this.userStore.currBusiness;
			this.usersStations = [];
			let finalStations = [];
			this.kitchenMonitorsStore.getBusinessStations(stations=>{
				for(let userId in this.kitchenMonitorsStore.stationsMap) {
					let currStation = this.kitchenMonitorsStore.stationsMap[userId];
					if (currStation.station) {
						finalStations.push({
							...currStation,
							email: currStation.email,
							title: currStation.email,
							buttonTitle: this.getString('categories'),
							callbackButton: ()=>{
								this.openBottomSheetCategorySettings = true;
								this.openStationId = Number(userId);
							},
							user_id: Number(userId),
						});
					}
				}
				if(currBusiness === this.userStore.currBusiness) {
					this.usersStations = finalStations;
				}
				if(cb) { cb() }
			}, !!force);
		},
		changeMenu(i) {
			let menus = this.sortedMenus;
			if(i < menus.length) {
				let selectedMenu = menus[i];
				if(selectedMenu) {
					this.menuStore.changeModMenu(selectedMenu.menu_id);
				}
			}
		},
		initMenu() {
			let menuId = this.menuStore.getMenuIndex(localStorage.getItem("last_menu_id"));
			if(menuId) {
				this.changeMenu(menuId);
			}
		},
	},
	mounted() {
		this.resetStationsList(null, true);
		if(!this.menuStore.loadedBusinessMenu && this.menuStore.currBusinessId !== null) {
			this.menuStore.loadMenu(this.initMenu);
		} else {
			this.initMenu();
		}

	},
	watch: {
		'userStore.currBusiness'(newVal) {
			if(newVal) {
				this.resetStationsList(null, true);
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.card-margin {
	max-width: 920px;
	margin: var(--main-padding) auto 0 auto;

	.blur-container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 150;
		background-color: rgba(0,0,0,0.3);
		border-radius: 0 0 13px 13px;
	}
	.plugin-heading {
		cursor: pointer;
		align-items: stretch;

		* {
			pointer-events: none;
		}

		.plugin-heading-icon {
			@include centered;
			width: 90px;
			padding: 20px 10px 20px 20px;

			.plugin-icon-container {
				@include centered;
				border-radius: 13px;
				width: 60px;
				height: 60px;
				background: transparent linear-gradient(225deg, var(--color-start) 0%, var(--color-end) 100%) 0% 0% no-repeat padding-box;
				box-shadow: 0px 3px 10px #00000040;

				div {
					@include centered;
					width: 30px;

					&:deep(svg) {
						width: 100%;
						height: 100%;

						.fill { fill: white; }
						.stroke { stroke: white; }
					}
				}
			}

			&.beta {

				.plugin-icon-container {
					background: transparent linear-gradient(225deg, #FFFFFF 0%, #E5EDF6 100%) 0% 0% no-repeat padding-box;

					div {
						&:deep(svg) {
							.fill { fill: $primary; }
							.stroke { stroke: $primary; }
						}
					}
				}
			}
		}
		.plugin-heading-text {
			@include centered;
			flex-direction: column;
			align-items: flex-start;
			width: calc(100% - 100px - 90px);
			padding: 10px;

			h3 {
				font-size: 14px;
			}
			p {
				font-size: 12px;
				line-height: 16px;
			}
			.requirement-tag {
				@include centered;
				position: relative;
				margin: 5px 6px 0 0;
				padding: 5px;
				background: linear-gradient(225deg, var(--color-start) 0%, #25529E 100%) 0% 0% no-repeat;
				border-radius: 7px;

				&:deep(svg)	{
					height: 12px;
					width: 12px;
					.fill { fill: white; }
					.stroke { stroke: white; }
				}
			}
		}
		.plugin-heading-status {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			align-items: center;
			width: 100px;
			padding: 10px 20px 10px 10px;

			.price-container p {
				font-size: 14px;
			}

			.open-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;

				.plugin-status-container {
					height: 27px;
					width: 27px;
					border-radius: 50%;
					background-color: #fff;
					box-shadow: 0 1px 3px $alpha;
					position: relative;

					&, & * {
						@include noSelect();
						pointer-events: none;
					}
					&:after {
						content: "";
						position: absolute;
						display: block;
						top: 6px;
						left: 6px;
						width: 15px;
						height: 15px;
						border-radius: 50%;
						background: #dfe9f3;
						box-shadow: inset 0 1px 1px $alpha_2;;
					}
					&.active {
						box-shadow: 0 0 2px $alpha;
						&::after {
							background-color: $secondary;
						}
					}
				}
			}

		}

		@media (max-width: 500px) {
			.plugin-heading-icon {
				width: 60px;
				padding: 14px 8px;

				.plugin-icon-container {
					width: 44px;
					height: 44px;

					div {
						width: 24px;
					}
				}
			}
			.plugin-heading-text {
				padding: 10px 8px 10px 0;
				width: calc(100% - 60px - 100px);
			}
		}
	}
	.plugin-dropdown {
		justify-content: center;
		align-items: flex-end;

		.dropdown-left, .dropdown-right {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			justify-content: flex-end;
		}

		.dropdown-left {
			width: calc(100% - 130px);
			position: relative;
			align-items: flex-start;
			align-self: stretch;
			padding-left: 80px;

			.icon-tick {
				width: 14px;

				&:deep(svg)	{
					width: 100%;
					height: 14px;
				}
			}
			p {
				padding-left: 5px;
				font-size: 12px;
				line-height: 16px;
				margin-bottom: 2px;
				max-width: calc(100% - 14px);
			}
			h4 {
				color: $primary;
				font-size: 12px;
				font-style: italic;
			}

			&:after {
				@include pseudoLine(100%, 1px, 0, 100%, $alpha_4);
			}
			&.no-after {
				width: 100%;

				&:after { display: none; }
			}
		}
		.dropdown-right {
			width: 130px;

			p {	color: $primary; }
			small {
				font-size: 12px;
				line-height: 14px;
				color: $primary;
			}
		}

		@media (max-width: 1200px) {
			.dropdown-left:not(.no-after) {
				width: calc(100% - 100px);
			}
			.dropdown-right {
				width: 100px;
			}
		}

		@media (max-width: 500px) {
			.dropdown-left {
				padding-left: 50px;
			}
		}

		@media (max-width: 460px) {
			.dropdown-left {
				padding: 8px;
				width: 100%;
				&:after {
					display: none;
				}
			}
			.dropdown-right {
				padding: 0 8px 8px 8px;
				width: 100%;
			}
		}
	}
	.button-row {
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
		padding-top: 20px;

		@media (max-width: 460px) {
			padding: 0 8px 8px 8px;
		}
	}
	.link-popup {
		color: $primary;
		padding-bottom: 3px;
		position: relative;
		cursor: pointer;
		&:after {
			content: "";
			position: absolute;
			display: block;
			width: calc(100% - 10px);
			height: 2px;
			background-color: var(--color-secondary);
			bottom: 0;
			left: 5px;
			transition: width 0.2s;
		}
	}
	:deep(.list-container .list-item) {
		padding: 0;
	}
	:deep(.dropdown-container .dropdown .dropdown-content) {
		position: relative;
		margin-top: 0;
		padding: 20px;

		&:before {
			@include pseudoLine(1px, 100%, 0, 0, $alpha_2);
		}
	}
	@media (max-width: 500px) {
		:deep(.dropdown-container .dropdown .dropdown-content) {
			padding: 8px;
		}
		.plugin-heading-status {
			padding-left: 0;
		}
	}
}
.custom-slot {
	margin-top: 20px;
	h3 {
		color: $primary;
	}
	.row-product-pos-carousel {
		display: flex;
		margin-top: 20px;
		align-items: center;
		.wrapper-img-custom {
			width: 120px;
			height: 120px;
			position: relative;
			min-width: 120px;
			border-radius: 13px;
			overflow: hidden;
			border: 1px solid transparent;
			transition: border 0.3s;
			@media (max-width: 390px) {
				width: 110px;
				height: 110px;
				min-width: 110px;
			}
			@media (max-width: 365px) {
				width: 95px;
				height: 95px;
				min-width: 95px;
			}
			@media (max-width: 345px) {
				width: 85px;
				height: 85px;
				min-width: 85px;
			}
			.button-corner {
				position: absolute;
				background-color: $primary;
				bottom: 0;
				right: 0;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 8px;
				border-radius: 13px 0 0 0;
				transition: background-color 0.3s;
			}
			&:hover {
				border: 1px solid $primary;
				.button-corner {
					background-color: rgba(7, 82, 163, 0.7);
				}
			}
			&:after {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				border-radius: 11px;
				z-index: 1;
				box-shadow: inset 1px 2px 3px rgba(7, 82, 163, 0.3019607843);
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
		.col-text {
			padding-left: 15px;
			p {
				color: $primary;
			}
			.description-product {
				font-size: 14px;
				line-height: 18px;
				@media (max-width: 390px) {
					font-size: 12px;
					line-height: 16px;
				}
			}
			.align-heading {
				display: flex;
				justify-content: space-between;
				.title-heading {
					font-weight: bold;
				}
				.price-carousel-product {
					font-weight: normal;
					color: $txt_0;
				}
			}
			.align-icon {
				margin-top: 4px;
				display: flex;
				justify-content: space-between;
				.parameters-icon-row {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 29px;
					width: 45px;
					border-radius: 7px;
					background-color: $alpha_1;
					box-shadow: inset 1px 1px 3px rgba(8, 82, 164, 0.3490196078);
					@media (max-width: 390px) {
						height: 25px;
						width: 40px;
					}
					@media (max-width: 345px) {
						height: 23px;
						width: 37px;
					}
					@media (max-width: 320px) {
						height: 21px;
						width: 34px;
					}
					p {
						font-size: 14px;
						line-height: 18px;
						@media (max-width: 320px) {
							font-size: 12px;
							line-height: 16px;
						}
					}
					img {
						width: 16px;
						height: 14px;
						margin-right: 2px;
					}
				}
			}
		}
	}
}
</style>